import "./QASection.css";

import React, { useState, useEffect } from "react";
import Footer from "../../Footer";
import { useNavigate } from "react-router-dom";

export const qaDataSemiPlanned = [
  {
    id: "step",
    header: "반기획 출판의 이해"
  },
  {
    id: "q1",
    question: "반기획 출판이란 무엇인가요?",
    answer: `반기획 출판은 저자와 출판사가 출간 비용, 제작 역할, 유통·마케팅 범위 등을 협의해 분담하는 방식입니다. 도서의 기획 방향과 제작 과정은 양측이 함께 논의하며, 판매 수익 정산 기준은 계약을 통해 정합니다.

            자비 출판보다 출판사의 기획·편집 참여도가 높고, 기획 출판보다는 저자가 비용과 역할을 일부 분담한다는 점이 특징입니다.`
  },
  {
    id: "q2",
    question: "반기획 출판은 자비 출판·기획 출판과 어떻게 다른가요?",
    answer: `반기획 출판은 저자와 출판사가 비용과 역할을 함께 나눈다는 점에서 자비 출판·기획 출판의 중간 성격을 가집니다.

            • 자비 출판 : 저자가 출간 비용을 부담하고, 출판사는 편집·디자인·제작·유통·정산 등 출간 과정을 지원합니다.
            • 반기획 출판 : 저자와 출판사가 출간 비용, 제작 역할, 유통·마케팅 범위 등을 협의해 분담합니다.
            • 기획 출판 : 출판사가 출간 비용과 판매 리스크를 부담하고, 기획부터 편집·제작·유통·마케팅까지 전 과정을 주도합니다.

            반기획 출판은 원고의 가능성은 있지만 전체 비용과 리스크를 출판사가 단독으로 부담하기 어려운 경우, 저자와 출판사가 함께 출간 가능성을 만들어가는 방식입니다.`
  },
  {
    id: "q3",
    question: "반기획 출판은 어떤 저자에게 적합한가요?",
    answer: `반기획 출판은 출판사의 기획·편집 역량을 활용하면서도, 저자 역시 출간 과정에 적극적으로 참여하고자 하는 경우에 적합합니다. 
            전문성을 갖춘 원고나 책과 연결할 수 있는 활동 기반이 있는 저자에게 잘 맞습니다.`
  },
  {
    id: "q4",
    question: "자비 출판보다 반기획 출판이 적합한 경우는 언제인가요?",
    answer: `원고의 주제와 독자층이 비교적 분명하고, 출판사의 기획·편집·마케팅 참여를 통해 책의 완성도와 확장 가능성을 높일 수 있다고 판단되는 경우 반기획 출판이 적합할 수 있습니다.`
  },  
  {
    id: "step",
    header: "출간 준비 및 검토"
  },
  {
    id: "q6",
    question: "반기획 출판은 어떤 원고에 적합한가요?",
    answer: `반기획 출판은 주제의 전문성이나 독자층은 분명하지만, 기획 출판으로 진행하기에는 시장 규모나 판매 예측이 제한적인 원고에 적합합니다. 
            특정 분야의 전문 지식, 실무 경험, 강의 콘텐츠, 컨설팅 노하우, 브랜드 확장 가능성이 있는 원고 등이 해당될 수 있습니다.`
  },
  {
    id: "q7",
    question: "반기획 출판은 모든 원고가 진행 가능한가요?",
    answer: `모든 원고가 반기획 출판으로 진행되는 것은 아닙니다. 
            반기획 출판은 출판사도 일정 수준의 기획·편집·유통 역량을 투입하는 방식이기 때문에, 원고의 주제, 완성도, 독자층, 시장성, 저자의 활동 계획 등을 검토한 뒤 진행 여부를 결정합니다.

            검토 결과에 따라 반기획 출판이 아닌 자비 출판, 전자책 중심 출간, 원고 보완 후 재검토 등을 제안드릴 수 있습니다.`,
//     table:`
// |  항목  | 총 비용 |출판사 부담 |저작자 부담|
// | 기획 및 편집 | 300만 원 | 150만 원 | 150만 원 |
// | 디자인 제작 | 200만 원 | 100만 원 | 100만 원 |
// | 인쇄 및 제본 | 400만 원 | 200만 원 | 200만 원 |
// | 마케팅 홍보 | 200만 원 | 100만 원 | 100만 원 |
// |  합계  | 1,100만 원 | 550만 원 | 550만 원 |`
  },
  {
    id: "q8",
    question: "출간 검토에서는 무엇을 보나요?",
    answer: `출간 검토에서는 원고의 주제, 목차 구성, 독자층, 시장성, 경쟁 도서와의 차별성, 저자의 전문성, 홍보 가능성 등을 종합적으로 검토합니다. 
            원고가 완성되어 있지 않더라도 기획안, 목차, 샘플 원고, 저자 소개 자료, 저자 활동 계획 등이 있다면 검토를 시작할 수 있습니다.`
  },
  {
    id: "q9",
    question: "출판사와 협업할 때 어떤 점을 미리 정하면 좋나요?",
    answer: `편집·디자인·마케팅 과정에서 의견이 다를 수 있으므로, 저자는 자신의 의도를 명확히 설명하고 출판사의 제안도 열린 태도로 검토하는 것이 좋습니다. 
            계약 조건과 역할 분담을 사전에 명확히 정리하는 것도 중요합니다.`
  },
  
  {
    id: "step",
    header: "비용 및 계약 조건"
  },
  {
    id: "q11",
    question: "반기획 출판에서 저자와 출판사는 어떤 역할을 나누나요?",
    answer: `반기획 출판에서는 저자와 출판사가 출간 과정의 역할을 협의해 나눕니다. 
            저자는 원고 집필, 자료 제공, 수정 검토, 홍보 활동 참여 등 책의 내용과 메시지를 구체화하는 역할을 담당합니다. 
            출판사는 기획 방향 검토, 편집·디자인·제작, 유통, 정산, 마케팅 지원 등 출간 실무를 담당합니다. 
            비용 부담, 마케팅 범위, 수익 정산 기준은 도서의 성격과 계약 조건에 따라 달라질 수 있습니다.`
  },
  {
    id: "q12",
    question: "비용과 수익 정산 기준은 어떻게 정하나요?",
    answer: `반기획 출판의 비용 분담은 원고의 성격, 제작 범위, 편집·디자인 난이도, 인쇄 여부, 마케팅 범위 등을 고려해 협의합니다. 
            고정된 비율로 일괄 적용하기보다는, 출판사와 저자가 어떤 역할과 비용을 부담할지 계약을 통해 정합니다. 
            판매 수익 역시 유통 수수료, 제작비 회수 구조, 마케팅 비용 부담 범위 등을 고려해 계약에서 정한 기준에 따라 정산합니다.`
  },
  {
    id: "q13",
    question: "계약 전 확인해야 할 사항은 무엇인가요?",
    answer: `계약 전에는 비용 분담 구조, 서비스 포함 범위, 편집 권한, 유통 범위, 마케팅 계획, 수익 정산 기준, 계약 기간, 해지 조건 등을 확인해야 합니다. 
            역할과 의사결정 기준을 계약서에 명확히 반영하는 것이 중요합니다.`
  },
  
  {
    id: "step",
    header: "기획·편집·디자인 및 출간 과정"
  },
  {
    id: "q16",
    question: "출판사의 기획 역할은 무엇인가요?",
    answer: `출판사는 원고의 시장성, 타깃 독자, 경쟁 도서, 도서 콘셉트, 목차 구성, 제목·부제 방향 등을 검토합니다. 
            저자의 원고와 전문성을 바탕으로 독자에게 더 잘 전달될 수 있는 책의 방향을 함께 만들어갑니다.`
  },
  {
    id: "q17",
    question: "편집 과정에서 저자의 역할은 무엇인가요?",
    answer: `저자는 원고와 자료를 제공하고, 편집 방향과 수정 제안에 대해 의견을 제시하며, 최종 원고와 교정지를 확인합니다. 
            반기획 출판은 협업형 출판 방식이므로 저자와 출판사 간의 충분한 소통이 중요합니다.`,
  },
  {
    id: "q18",
    question: "표지와 본문 디자인은 어떻게 정해지나요?",
    answer: `표지와 본문 디자인은 도서의 콘셉트, 독자층, 시장 포지션을 고려해 진행합니다. 
            저자의 의견도 참고하며, 최종 디자인 방향은 도서의 성격, 제작 조건, 마케팅 방향 등을 종합적으로 고려해 협의합니다.`
  },
  {
    id: "q19",
    question: "제작 과정은 어떻게 진행되나요?",
    answer: `최종 원고와 디자인 방향이 확정되면 본문 조판, 교정, 최종 파일 확정, 전자책 제작 또는 종이책 인쇄·POD 제작, ISBN 등록, 온라인 서점 및 유통 등록 과정을 거쳐 출간됩니다. 세부 일정은 도서의 장르, 분량, 제작 난이도, 출간 매체, 인쇄 방식 등에 따라 달라질 수 있습니다.`
  },
  {
    id: "q20",
    question: "출간 일정은 어떻게 정해지나요?",
    answer: `출간 일정은 원고 완성도, 편집 일정, 디자인 확정 일정, 제작 일정, 마케팅 계획, 출판사의 전체 출간 일정 등을 고려해 정합니다. 
            저자의 원고 제출과 피드백 속도도 전체 일정에 영향을 줄 수 있습니다.`
  },
  {
    id: "q21",
    question: "종이책과 전자책을 함께 출간할 수 있나요?",
    answer: `도서의 성격과 출간 전략에 따라 종이책, 전자책, 오디오북 등 다양한 포맷으로 출간할 수 있습니다. 
            어떤 매체로 출간할지는 계약 범위와 출간 전략에 따라 정합니다.`
  },
  {
    id: "q22",
    question: "의견이 다를 때는 어떻게 조율하나요?",
    answer: `의견 차이가 있을 경우 담당 편집자와 저자가 먼저 협의합니다. 
            필요한 경우 편집 책임자나 기획 담당자가 함께 논의해 책의 방향을 조정합니다. 
            원칙적으로 저자의 의도와 출판사의 시장 판단 사이에서 균형점을 찾는 방식으로 진행합니다.`
  },  

  {
    id: "step",
    header: "유통·판매 및 정산"
  },
  {
    id: "q23",
    question: "반기획 출판 도서는 어디에서 판매되나요?",
    answer: `계약 범위에 따라 주요 온라인 서점, 전자책 플랫폼, 오프라인 서점 등을 통해 판매할 수 있습니다. 
            유통 채널은 도서의 형식, 제작 방식, 판매 전략에 따라 달라질 수 있습니다.`
  },
  {
    id: "q24",
    question: "오프라인 서점에도 진열될 수 있나요?",
    answer: `종이책으로 제작하는 경우 오프라인 서점 유통을 검토할 수 있습니다. 
            다만 실제 진열 여부는 유통 조건, 서점의 판단, 판매 흐름 등에 따라 달라질 수 있으며, 모든 서점 진열이 보장되는 것은 아닙니다.`
  },
  {
    id: "q25",
    question: "책의 정가는 어떻게 정해지나요?",
    answer: `정가는 제작비, 페이지 수, 판형, 경쟁 도서 가격, 독자층, 유통 조건 등을 고려해 출판사와 저자가 협의해 결정합니다. 
            필요한 경우 시장 반응에 따라 할인, 프로모션, 가격 조정 등을 검토할 수 있습니다.`
  },
  {
    id: "q26",
    question: "판매 수익은 어떻게 배분되나요?",
    answer: `판매 수익은 계약에서 정한 기준에 따라 배분됩니다. 
            판매 수익에서 유통 수수료, 반품, 할인, 결제 수수료 등 외부 비용을 제외한 뒤, 저자와 출판사가 협의한 기준에 따라 정산합니다.`
  },
  {
    id: "q27",
    question: "정산 주기와 지급 방식은 어떻게 정하나요?",
    answer: `정산 주기와 지급 방식은 계약 조건과 유통 채널의 정산 일정에 따라 정합니다. 
            일반적으로 일정 기간의 판매 내역을 모아 정산하고, 정산 자료를 바탕으로 저자에게 지급합니다.`
  },
  {
    id: "q28",
    question: "판매 실적은 어떻게 확인하나요?",
    answer: `판매 실적은 정산 자료 또는 저자 포털을 통해 확인할 수 있습니다. 
            제공되는 정보의 범위와 업데이트 주기는 유통 채널과 계약 조건에 따라 달라질 수 있습니다.`
  },
  {
    id: "q29",
    question: "선급금이나 최소 보장 수익이 있나요?",
    answer: `반기획 출판에서는 선급금이나 최소 보장 수익이 없는 경우가 일반적입니다. 
            다만 도서의 성격, 저자의 이력, 계약 조건에 따라 별도 협의가 가능할 수 있습니다.`
  },
      
  {
    id: "step",
    header: "마케팅 및 홍보"
  },
  {
    id: "q30",
    question: "마케팅은 어떻게 진행되나요?",
    answer: `마케팅은 출판사와 저자가 역할을 나누어 진행합니다. 
            출판사는 도서 소개 자료, 온라인 서점용 도서 정보, 홍보 카피, 기본 홍보 전략 등을 준비하고, 
            저자는 자신의 전문성·네트워크·SNS 등을 활용해 홍보에 참여할 수 있습니다.`
  },
  {
    id: "q31",
    question: "저자는 어떤 방식으로 마케팅에 참여할 수 있나요?",
    answer: `저자는 개인 SNS, 블로그, 뉴스레터, 강연, 커뮤니티, 지인 네트워크 등을 활용해 책을 알릴 수 있습니다. 
            또한 인터뷰, 기고, 북토크, 강연 연계 등 출판사의 홍보 활동에 협력하면 도서의 노출과 독자 접점을 넓히는 데 도움이 됩니다.`
  },
  {
    id: "q32",
    question: "추가 마케팅은 어떻게 진행할 수 있나요?",
    answer: `광고, 상세페이지 제작, 서평단, 북토크, 강연 연계, SNS 캠페인 등 추가 마케팅이 필요한 경우 별도 협의를 통해 진행할 수 있습니다. 
            추가 마케팅 여부와 진행 범위는 도서의 성격, 예산, 기대 효과를 함께 검토해 결정합니다.`
  },
  {
    id: "q33",
    question: "마케팅 결과는 어떻게 점검하나요?",
    answer: `판매량, 온라인 서점 반응, 검색량, 리뷰, SNS 언급, 언론 노출, 행사 반응 등을 바탕으로 마케팅 결과를 점검할 수 있습니다.
            필요한 경우 성과 분석 결과에 따라 홍보 메시지나 채널을 조정할 수 있습니다.`
  },
  
  {
    id: "step",
    header: "사후 관리"
  },
  {
    id: "q34",
    question: "출간 후 어떤 관리 서비스를 받을 수 있나요?",
    answer: `출간 후에는 계약 범위에 따라 서점 유통 상태 관리, 판매 및 정산 자료 제공, 도서 정보 수정 지원, 독자 문의 접수 및 확인, 추가 인쇄 협의 지원 등을 받을 수 있습니다. 반기획 출판은 저자와 출판사가 역할을 나누어 운영하는 방식이므로, 도서 판매, 정산, 유통 정보 관리, 후속 홍보 등 출간 이후 운영 범위는 계약 조건에 따라 정합니다.`
  },
  {
    id: "q35",
    question: "추가 인쇄는 언제 검토하나요?",
    answer: `추가 인쇄는 재고 현황, 판매 추이, 유통 요청, 마케팅 계획 등을 고려해 검토합니다. 
            반기획 출판의 경우 추가 인쇄 비용과 진행 여부, 의사결정 방식은 계약 조건에 따라 저자와 출판사가 협의해 정합니다.`
  },
  {
    id: "q36",
    question: "판매가 기대에 미치지 못할 경우 어떻게 대응하나요?",
    answer: `판매가 기대에 미치지 못할 경우 도서 소개 문구, 타깃 독자, 홍보 채널, 가격 정책, 추가 마케팅 가능성 등을 점검합니다. 
            필요에 따라 홍보 방향을 조정하거나 저자 활동과 연계한 홍보 방안을 검토할 수 있습니다.`
  },
  
  {
    id: "step",
    header: "권리 및 계약 유의사항"
  },
  {
    id: "q37",
    question: "저작권은 누구에게 있나요?",
    answer: `원고의 저작권은 원칙적으로 저작자에게 있습니다. 
            출판사는 계약에서 정한 범위 안에서 도서를 제작·출간·유통할 수 있는 권한을 갖습니다. 
            출판권, 전자책 발행 및 유통 권한, 오디오북, 해외 출간, 2차 저작물 등 세부 권리 범위는 계약 조건에 따라 정합니다.`
  },
  {
    id: "q38",
    question: "2차 저작물 권리는 어떻게 정하나요?",
    answer: `오디오북, 번역 출간, 해외 출간, 강의 콘텐츠, 영상화 등 2차 저작물 권리는 계약에서 별도로 정합니다. 
            출판사가 기획·제작·유통에 참여하는 범위에 따라 수익 배분 기준도 달라질 수 있습니다.`
  },
  {
    id: "q39",
    question: "계약을 중도 해지할 수 있나요?",
    answer: `계약 해지는 계약서에서 정한 조건에 따라 가능합니다. 
            일반적으로 양측 합의, 계약 위반, 진행 불가 사유 등이 있을 때 해지 절차를 진행할 수 있습니다. 
            해지 시 제작물 사용 범위, 이미 발생한 비용, 재고 처리, 유통 종료 시점 등을 함께 확인해야 합니다.`
  },
  {
    id: "q40",
    question: "AI를 활용해 작성한 원고도 출간할 수 있나요?",
    answer: `AI를 활용해 작성한 원고도 출간 검토가 가능합니다. 다만 AI 도구를 사용한 경우에는 사용 여부와 활용 범위를 사전에 알려주셔야 합니다. AI 생성 문장, 이미지, 도표, 번역문 등은 저작권·표절·사실 오류 문제가 발생할 수 있으므로 출간 전 확인이 필요하며, 최종 원고에 대한 책임은 저작자에게 있습니다.

            또한 기획, 원고 작성, 편집, 번역, 이미지 생성 과정에서 AI를 일부 또는 전부 활용한 경우, 온라인 서점 전자책 등록 시 ‘AI 생성·활용 도서’임을 표기해야 할 수 있습니다. 단순한 본문 교정·교열, 표지 디자인 보조 활용 등은 적용 범위가 달라질 수 있으므로, AI 활용 여부와 범위는 출간 전 반드시 확인해 주시기 바랍니다.`
  },
  {
    id: "q41",
    question: "표절이나 저작권 침해 문제가 발생하면 어떻게 되나요?",
    answer: `원고 내용의 저작권 침해, 표절, 명예훼손, 초상권 침해 등 법적 문제가 발생할 경우 원칙적으로 저작자가 책임져야 합니다. 
            다만 출판 과정에서 확인이 필요한 사항은 출판사와 협의해 검토할 수 있습니다. 인용 자료, 이미지, 도표, 사진 등을 사용할 때는 출처와 사용 권한을 반드시 확인해야 합니다.`
  },

  {
    id: "step",
    header: "저자 포털 이용 안내"
  },
  {
    id: "q42",
    question: "저자 포털에서는 무엇을 확인할 수 있나요?",
    answer: `저자 포털에서는 계약 범위에 따라 출간 진행 상황, 유통 상태, 판매 및 정산 자료, 도서 정보 등을 확인할 수 있습니다. 
            제공 기능은 서비스 유형과 운영 범위에 따라 달라질 수 있습니다.`
  },
  {
    id: "q43",
    question: "저자 포털을 통해 정산 자료를 확인할 수 있나요?",
    answer: `저자 포털에서 판매 내역과 정산 정보를 확인할 수 있습니다. 
            자료 제공 시점과 세부 항목은 유통 채널의 정산 주기와 계약 조건에 따라 달라질 수 있으며, 필요한 경우 별도 정산 자료로 안내드릴 수 있습니다.`
  },
  {
    id: "q44",
    question: "포털 이용이 어려우면 어떻게 하나요?",
    answer: `포털 이용이 어려운 경우 이메일 문의를 통해 이용 방법을 안내받을 수 있습니다. 
            포털에서 제공되는 기능과 지원 범위는 계약 조건과 서비스 유형에 따라 달라질 수 있습니다.`
  },
  
  {
    id: "step",
    header: "상담 및 문의"
  },
  {
    id: "q45",
    question: "반기획 출판 상담은 어떻게 신청하나요?",
    answer: `홈페이지 문의, 이메일, 전화 등을 통해 상담을 신청할 수 있습니다. 
            상담 시 원고 또는 기획안, 저자 소개, 출간 목적, 예상 독자층을 함께 보내주시면 검토가 수월합니다.`
  },
  {
    id: "q46",
    question: "상담 전에 어떤 자료를 준비하면 좋나요?",
    answer: `원고 파일, 목차, 샘플 원고, 저자 이력, 출간 목적, 예상 독자층, 참고 도서, 홍보 가능성이나 저자 활동 계획 등을 준비하면 좋습니다. 
            원고가 완성되지 않았더라도 기획안과 샘플 원고가 있다면 상담이 가능합니다.`
  },
  
];



const StepHeader = ({ header }) => (
  <div className="qa-step-header">
    <h4>{header}</h4>
  </div>
);

const QAItem = ({ id, question, answer, table, isOpen, onToggle }) => {
  const renderAnswer = () => {
    const answerContent = answer && (
      <p style={{ whiteSpace: "pre-line", marginBottom: table ? "1rem" : 0 }}>
        {answer}
      </p>
    );

    if (table) {      
      const lines = table.trim().split("\n");    
      const rows = lines
        .filter(line => line.trimStart().startsWith("|"))
        .map(line =>  
          line
            .trimStart()      
            .split("|")
            .slice(1, -1)
            .map(cell => cell.trim())
        );

      const [header, , ...body] = rows;

      return (
        <>
          {answerContent}
          <table className="qa-table">
            <thead>
              <tr>
                {header.map((cell, idx) => (
                  <th key={idx}>{cell}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {body.map((row, rIdx) => (
                <tr key={rIdx}>
                  {row.map((cell, cIdx) => (
                    <td key={cIdx}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </>
      );
    } else {
      return answerContent;
    }
  };


  return (
    <div className={`qa-card ${isOpen ? "open" : ""}`}>
      <div
        className="qa-card-question-header"
        onClick={() => onToggle(id)}
        role="button"
        aria-expanded={isOpen}
        aria-controls={`qa-answer-${id}`}
        tabIndex="0"
      >
        <h3>{question}</h3>
        <img
          src="./images/arrow-down.png"
          alt="Toggle dropdown"
          className="qa-card-arrow"
        />
      </div>
      <div
        id={`qa-answer-${id}`}
        className="qa-card-answer"
        aria-hidden={!isOpen}
      >
        {renderAnswer()}
      </div>
    </div>
  );
};

const QASection = () => {
  const navigate = useNavigate();
  const [openFAQId, setOpenFAQId] = useState(null);

  const handleToggleFAQ = (id) => {
    setOpenFAQId((prevId) => (prevId === id ? null : id));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="qa-section-container">
        <div className="qa-section">          
          <div className="qa-section-header" >
            <button
              onClick={() => {
                navigate("/", { state: { scrollToFAQ: true } }); // 돌아갈 때 flag 전달
              }}
              className="carousel-nav-button prev"
              aria-label="Previous slide"
            >
              ❮
            </button>
            <h2>반기획 출판 FAQ</h2>
          </div>
          <div className="qa-cards-container">
            {qaDataSemiPlanned.map((qa, index) => {
              if (qa.id === "step") {
                return <StepHeader key={`step-${index}`} header={qa.header} />;
              }
              return (
                <QAItem
                  key={qa.id}
                  id={qa.id}
                  question={qa.question}
                  answer={qa.answer}
                  table={qa.table}
                  isOpen={openFAQId === qa.id}
                  onToggle={handleToggleFAQ}
                />
              );
            })}
          </div>         
        </div>      
      </section>
      <Footer />
    </div>
  );
};

export default QASection;
